import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-login-error',
  templateUrl: './login-error.component.html',
  styleUrls: ['./login-error.component.scss']
})
export class LoginErrorComponent implements OnInit {

  constructor( private route: ActivatedRoute,private router: Router,public dialogRef: MatDialogRef<LoginErrorComponent>,
    @Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit(): void { }

  forgetpassword(){
    this.dialogRef.close(); 
    this.router.navigate(['../forgot-password'], { relativeTo: this.route })
  }

  closeDialog(){
    this.dialogRef.close();
  }

}
